import React, { useEffect } from 'react'
import JSBridge from '@xpeng/js-bridge'
import Toast from '@xpeng/rc-toast'
import PopupBottomModal from '../../../../components/popup-bottom-modal'
import { CHARGE_CDN, isXPApp } from '../../../../utils/constants'
import { trackGdp } from '../../../../utils/gio-report'

import './index.less'

interface Props {
  visible: boolean
  onClose: () => void
  qrCode: string
}

const StationCodeModal = ({
  visible,
  onClose,
  qrCode
}: Props) => {
  const saveToAlbumInApp = () => {
    trackGdp('P20075', 'B028')

    JSBridge.callHandler('saveToAlbum', { url: qrCode })
    .then(res => {
      const { code } = res
      if (code === 0) {
        Toast.show('保存成功')
        onClose()
      } else if (code === 10) {
        Toast.show('相册权限未打开，保存失败', {
          containerStyle: {
            zIndex: 9999
          }
        })
      } else {
        Toast.show('保存失败', {
          containerStyle: {
            zIndex: 9999
          }
        })
      }
    })
    .catch(err => console.log('saveToAlbum err', err))
  }

  const btnInfo = {
    text: isXPApp ? '点我保存图片' : '长按图片保存',
    onClick: isXPApp ? saveToAlbumInApp : () => {}
  }

  useEffect(() => {
    if (isXPApp) {
      // 图片保存按钮曝光
      trackGdp('P20075', 'B027')
    }
  }, [])

  return (
    <PopupBottomModal
      visible={visible}
      onClose={onClose}
      title='保存线下码'
    >
      <div className='station-code-modal-wrap'>
        <div className='title'>将二维码打印并张贴在家充桩上，方便大家扫码充电</div>
        <div className='qrcode-wrap'>
          <img className='qrcode' src={qrCode}  alt='' />
          <div className='save-btn' onClick={btnInfo.onClick}>
            <img className='icon-download' src={`${CHARGE_CDN}/sharing/qrcode_download.png`} alt='' />
            <div className='text'>{btnInfo.text}</div>
          </div>
        </div>
      </div>
    </PopupBottomModal>
  )
}

export default StationCodeModal